'use client';

import { navBecomeProvider, navHome, navSignIn, rdNavLegal } from 'Workadabra/translations';
import { AuthControls } from '@bomdisoft/auth-bff';
import { Brand, CreditCardRoundedIcon, DashboardCustomizeRoundedIcon, TopBar as SharedTopBar, type TopBarSecondaryLink } from '@bomdisoft/components';
import { account, billing, getLanguageFromLocale, goToApp, manageAccount, signOut } from '@bomdisoft/translations';
import { getSharedBillingUrl, getSharedLoginUrl } from '@bomdisoft/utilities';
import { useParams, usePathname } from 'next/navigation';

const authAccountHref = (): string | undefined => {
  const base = process.env.NEXT_PUBLIC_BOMDISOFT_AUTH_URL;
  return base ? `${base.replace(/\/+$/, '')}/account` : undefined;
};

const appOrigin = (): string => (process.env.NEXT_PUBLIC_WORKADABRA_APP_ORIGIN ?? 'https://app.workadabra.com').replace(/\/+$/, '');

const LEGAL_PATH_SUFFIXES = ['/privacy-policy', '/terms-of-service', '/cookie-policy', '/gdpr'];

export const WorkadabraNavbar = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);
  const pathname = usePathname() ?? '';
  const isLegal = LEGAL_PATH_SUFFIXES.some(suffix => pathname.endsWith(suffix) || pathname.includes(`${suffix}/`));

  const secondaryLink: TopBarSecondaryLink = isLegal ? { href: `/${langPrefix}`, label: navHome[language], testId: 'top-bar-legal' } : { href: `/${langPrefix}/privacy-policy`, label: rdNavLegal[language], testId: 'top-bar-legal' };

  return (
    <SharedTopBar
      authSlot={
        // Sign-in and sign-up route through the shared login with the product key,
        // never this landing's own BFF: workadabra has an app, so finishing auth on
        // the landing is a dead end.
        <AuthControls
          accountHref={authAccountHref()}
          items={[{ external: true, href: getSharedBillingUrl(), icon: <CreditCardRoundedIcon />, label: billing[language], testId: 'top-bar-billing' }]}
          leadingItems={[{ href: appOrigin(), icon: <DashboardCustomizeRoundedIcon />, label: goToApp[language], testId: 'top-bar-app' }]}
          manageAccountLabel={manageAccount[language]}
          menuLabel={account[language]}
          signInHref={getSharedLoginUrl('workadabra')}
          signInLabel={navSignIn[language]}
          signOutLabel={signOut[language]}
          signUpHref={getSharedLoginUrl('workadabra', 'signup')}
          signUpLabel={navBecomeProvider[language]}
        />
      }
      brand={<Brand gap={0.15} href={`/${langPrefix}`} logoHeight={19} logoWidth={32} priority size={24} testId='top-bar-brand' wordmarkSuffix='orkadabra' />}
      maxWidth={1280}
      secondaryLink={secondaryLink}
    />
  );
};
